<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("my_task") }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <div class="card card-with-search border-0 card-with-shadow">
      <div class="text-justify">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
      <!-- <button
        type="button"
        class="btn btn-primary mr-2"
        data-dismiss="modal"
        @click="submit"
      >
        {{ $t("update") }}
      </button> -->
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
// import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
// import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";

export default {
  name: "Tabs",
  extends: CoreLibrary,
  mixins: [ModalMixin],
  props: {
    tableId: String,
    id: Number,
    afterSubmitDone:Function,
  },
  data() {
    return {
      modalId: "my_task_modal",
      icon: "settings",
      isAddEditModalActive: false,
      tabsHorizontal: [
        {
          icon: "info",
          name: "Detail",
          component: "task-detail",
          permission: '',
          props: {id:this.id, tableId:this.tableId, refresh:this.afterSubmitDone}
        },
        {
          icon: "link",
          name: "Questionnaire",
          component: "task-form-mainstep",
          permission: '',
          props: {id:this.id}
        },
        {
          icon: "paperclip",
          name: "Attach document",
          component: "task-attach-document",
          permission: '',
          props: {id:this.id},
          style: 'float: right',
        },
      ],
    };
  },
};
</script>
